/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
  var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
  if (api && typeof api.t === 'function') return api.t(key, params);
  if (typeof module === 'object' && module.exports && typeof require === 'function') {
    var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
    var dict = require('../json/i18n/' + lang + '/js-runtime.json');
    var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
    return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
  }
  return key;
}

/* SIATKA-WIDOK (22.09.2026) — jeden mechanizm dla siatek losowan:
   /wyniki/{gra} (tabela losowan) i /{gra}/statystyki/rytmy (siatka rytmow).

   Kontener [data-sw] obejmuje .tabela-scroll z tabela i przyciski
   [data-sw-akcja]: pelny | dopasuj | wyrownaj | osie | rytmy | plus | minus.
   data-sw-lead   — ile kolumn z lewej to etykiety wiersza (nr, data),
   data-sw-label  — ktora z nich idzie do naglowka po zamianie osi.

   Tryby: zwykly (przewijanie strony, bez transformacji), dopasuj (skala do
   szerokosci; po powiekszeniu przeciaganie), pelny (nakladka na caly ekran,
   przeciaganie jednym palcem, powiekszanie dwoma albo kolkiem myszy).
   Zamiana osi pracuje na KOPII tabeli — oryginal zostaje dla skryptow,
   ktore go stronicuja (wyniki.html.twig), a kopia odswieza sie po
   zdarzeniu `sw:odswiez` na kontenerze. */
(function () {
  'use strict';
  var MIN = 0.2, MAX = 4;

  function Widok(el) {
    this.el = el;
    this.vp = el.querySelector('.tabela-scroll');
    this.orig = this.vp && this.vp.querySelector('table');
    if (!this.orig) return;
    this.lead = parseInt(el.getAttribute('data-sw-lead') || '1', 10);
    this.labelIdx = parseInt(el.getAttribute('data-sw-label') || '0', 10);
    this.s = 1; this.fit = 1; this.x = 0; this.y = 0;
    this.pts = {}; this.ruch = 0;
    this.podlacz();
  }

  Widok.prototype.t = function () { return this.kopia || this.orig; };
  Widok.prototype.tryb = function () { return this.el.classList.contains('sw-pelny') || this.el.classList.contains('sw-dopasuj'); };

  Widok.prototype.podlacz = function () {
    var w = this;
    w.el.addEventListener('click', function (e) {
      var b = e.target.closest('[data-sw-akcja]');
      if (b && w.el.contains(b)) w.akcja(b.getAttribute('data-sw-akcja'), b);
    });
    w.el.addEventListener('sw:odswiez', function () { if (w.kopia) w.osie(true); w.dopasuj(true); });
    // Krzyz przy najechaniu myszka (22.09.2026, daro): wiersz podswietla CSS
    // (tr:hover), kolumne — atrybut data-sw-hl na jej komorkach.
    w.vp.addEventListener('mouseover', function (e) { w.krzyz(e.target.closest('td, th')); });
    w.vp.addEventListener('mouseleave', function () { w.krzyz(null); });
    ['pointerdown', 'pointermove', 'pointerup', 'pointercancel'].forEach(function (n) {
      w.vp.addEventListener(n, function (e) { w[n](e); });
    });
    // Po przeciagnieciu nie otwieramy linku z daty, na ktorym palec skonczyl.
    w.vp.addEventListener('click', function (e) { if (w.ruch > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
    w.vp.addEventListener('wheel', function (e) {
      if (!w.tryb() || (!e.ctrlKey && !w.el.classList.contains('sw-pelny'))) return;
      if (e.target.closest('select,input,button')) return;
      e.preventDefault();
      if (!e.ctrlKey) {
        var krok = e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? w.vp.clientHeight : 1;
        w.x -= (e.shiftKey ? e.deltaY : e.deltaX) * krok;
        if (!e.shiftKey) w.y -= e.deltaY * krok;
        w.rysuj();
        return;
      }
      var r = w.vp.getBoundingClientRect();
      w.zoom(e.deltaY < 0 ? 1.15 : 1 / 1.15, e.clientX - r.left, e.clientY - r.top);
    }, { passive: false });
    w.vp.addEventListener('keydown', function (e) {
      if (!w.tryb() || e.target !== w.vp) return;
      var ruch = { ArrowDown: [0, -60], ArrowUp: [0, 60], ArrowRight: [-60, 0], ArrowLeft: [60, 0], PageDown: [0, -w.vp.clientHeight * 0.8], PageUp: [0, w.vp.clientHeight * 0.8] }[e.key];
      if (ruch) { w.x += ruch[0]; w.y += ruch[1]; }
      else if (e.key === 'Home') { w.x = 0; w.y = 0; }
      else if (e.key === 'End') w.y = -w.t().offsetHeight * w.s;
      else return;
      e.preventDefault(); w.rysuj();
    });
    document.addEventListener('fullscreenchange', function () {
      if (!document.fullscreenElement && w.el.classList.contains('sw-pelny')) w.pelny(false);
      else if (document.fullscreenElement === w.el) w.dopasuj(true);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && w.el.classList.contains('sw-pelny')) w.pelny(false); });
    window.addEventListener('resize', function () { w.dopasuj(true); });
  };

  Widok.prototype.akcja = function (a, b) {
    if (a === 'pelny') this.pelny(!this.el.classList.contains('sw-pelny'));
    else if (a === 'dopasuj') { this.przelacz('sw-dopasuj', b); this.dopasuj(); }
    else if (a === 'wyrownaj') this.wyrownaj();
    else if (a === 'rytmy') { this.przelacz('sw-rytmy', b); this.dopasuj(true); }
    else if (a === 'osie') { this.przelacz('sw-osie-on', b); this.osie(this.el.classList.contains('sw-osie-on')); this.dopasuj(); }
    else if (a === 'plus' || a === 'minus') this.zoom(a === 'plus' ? 1.25 : 0.8, this.vp.clientWidth / 2, this.vp.clientHeight / 2);
  };

  Widok.prototype.przelacz = function (kl, b) {
    var on = this.el.classList.toggle(kl);
    if (b) b.setAttribute('aria-pressed', on ? 'true' : 'false');
  };

  Widok.prototype.pelny = function (on) {
    var el = this.el, b = el.querySelector('[data-sw-akcja="pelny"]');
    if (el.classList.contains('sw-pelny') === on) return;
    el.classList.toggle('sw-pelny', on);
    document.documentElement.classList.toggle('sw-blokada', on);
    if (b) b.setAttribute('aria-pressed', on ? 'true' : 'false');
    // Renderer wyników montuje cały wybrany zakres przed pomiarem geometrii.
    el.dispatchEvent(new CustomEvent('sw:pelny', { detail: { active: on } }));
    // iPhone nie ma Fullscreen API dla elementow — zostaje sama nakladka CSS.
    var req = el.requestFullscreen || el.webkitRequestFullscreen;
    if (on && req && !document.fullscreenElement) { try { var p = req.call(el); if (p && p.catch) p.catch(function () {}); } catch (e) {} }
    if (!on && document.fullscreenElement) document.exitFullscreen();
    this.dopasuj();
    if (on) this.vp.focus({ preventScroll: true });
    else if (b) b.focus({ preventScroll: true });
  };

  // Skala startowa: cala SZEROKOSC tabeli (80 liczb Multi Multi to szerokosc,
  // nie wysokosc); dalej w pionie przesuwa sie palcem albo przewija.
  Widok.prototype.dopasuj = function (zachowaj) {
    var t = this.t(), vp = this.vp;
    t.style.transform = ''; vp.style.height = '';
    if (!this.tryb()) { vp.classList.remove('sw-vp'); return; }
    vp.classList.add('sw-vp');
    var tw = Math.max(t.scrollWidth, t.offsetWidth), th = Math.max(t.scrollHeight, t.offsetHeight);
    var pelny = this.el.classList.contains('sw-pelny');
    var sw = (vp.clientWidth - 2) / tw;
    var stare = this.fit;
    this.fit = Math.min(1, sw);
    if (!pelny) vp.style.height = Math.max(160, Math.ceil(th * this.fit)) + 'px';
    if (!zachowaj || this.s < this.fit || Math.abs(this.s - stare) < 1e-3) { this.s = this.fit; this.x = 0; this.y = 0; }
    this.rysuj();
  };

  // Przywraca lewy gorny rog bez zmiany powiekszenia wybranego przez gracza.
  // W trybie zwyklym resetuje natywne przewiniecie, a w dopasowaniu/pelnym
  // ekranie — przesuniecie transformacji. Fit przeliczamy, bo powiekszenie
  // przegladarki moglo w miedzyczasie zmienic szerokosc widoku.
  Widok.prototype.wyrownaj = function () {
    var skala = this.s;
    this.vp.scrollLeft = 0;
    this.vp.scrollTop = 0;
    if (!this.tryb()) return;
    this.dopasuj(true);
    this.s = Math.min(MAX, Math.max(this.fit, skala));
    this.x = 0;
    this.y = 0;
    this.rysuj();
  };

  Widok.prototype.zoom = function (k, cx, cy) {
    if (!this.tryb()) { this.el.classList.add('sw-dopasuj'); this.dopasuj(); }
    var s = Math.min(MAX, Math.max(Math.min(MIN, this.fit), this.s * k)), f = s / this.s;
    this.x = cx - (cx - this.x) * f; this.y = cy - (cy - this.y) * f; this.s = s;
    this.rysuj();
  };

  Widok.prototype.rysuj = function () {
    var t = this.t();
    this.x = Math.min(0, Math.max(Math.min(0, this.vp.clientWidth - t.offsetWidth * this.s), this.x));
    this.y = Math.min(0, Math.max(Math.min(0, this.vp.clientHeight - t.offsetHeight * this.s), this.y));
    t.style.transform = 'translate(' + this.x + 'px,' + this.y + 'px) scale(' + this.s + ')';
    // Na stronie przy skali „dopasuj" palec ma przewijac strone, nie tabele.
    var chwyt = this.el.classList.contains('sw-pelny') || this.s > this.fit + 1e-3;

    this.vp.classList.toggle('sw-chwyt', chwyt);
  };

  Widok.prototype.pointerdown = function (e) {
    if (!this.tryb() || (e.pointerType === 'mouse' && e.button !== 0)) return;
    this.pts[e.pointerId] = { x: e.clientX, y: e.clientY };
    if (Object.keys(this.pts).length === 1) this.ruch = 0;
  };

  Widok.prototype.pointermove = function (e) {
    var p = this.pts[e.pointerId]; if (!p) return;
    var ids = Object.keys(this.pts);
    if (ids.length === 1 && this.vp.classList.contains('sw-chwyt')) {
      this.x += e.clientX - p.x; this.y += e.clientY - p.y;
      this.ruch += Math.abs(e.clientX - p.x) + Math.abs(e.clientY - p.y);
      if (this.ruch > 6 && !this.vp.hasPointerCapture(e.pointerId)) this.vp.setPointerCapture(e.pointerId);
    } else if (ids.length === 2) {
      var o = this.pts[ids[0] == e.pointerId ? ids[1] : ids[0]];
      var d0 = Math.hypot(p.x - o.x, p.y - o.y), d1 = Math.hypot(e.clientX - o.x, e.clientY - o.y);
      var r = this.vp.getBoundingClientRect();
      if (d0 > 0) this.zoom(d1 / d0, (e.clientX + o.x) / 2 - r.left, (e.clientY + o.y) / 2 - r.top);
      this.ruch = 99;
    }
    p.x = e.clientX; p.y = e.clientY;
    this.rysuj();
  };

  Widok.prototype.pointerup = function (e) {
    var w = this; delete w.pts[e.pointerId];
    // `click` przychodzi zaraz po puszczeniu — potem licznik ruchu wraca do zera.
    if (!Object.keys(w.pts).length) setTimeout(function () { w.ruch = 0; }, 0);
  };
  Widok.prototype.pointercancel = Widok.prototype.pointerup;

  Widok.prototype.krzyz = function (c) {
    var t = c && c.closest('table'), i = c ? c.cellIndex : -1;
    var lead = t && t === this.kopia ? 1 : this.lead;
    if (!t || !this.vp.contains(t) || i < lead) { t = null; i = -1; }
    if (t === this.hlT && i === this.hlI) return;
    if (this.hlT) Array.prototype.forEach.call(this.hlT.querySelectorAll('[data-sw-hl]'), function (x) { x.removeAttribute('data-sw-hl'); });
    this.hlT = t; this.hlI = i;
    if (!t) return;
    Array.prototype.forEach.call(t.rows, function (r) { var x = r.cells[i]; if (x) x.setAttribute('data-sw-hl', ''); });
  };

  // Zamiana osi: wiersze = liczby, kolumny = losowania. Tylko widoczne wiersze
  // oryginalu (stronicowanie i szukajka w wynikach dzialaja dalej na nim).
  Widok.prototype.osie = function (on) {
    if (this.kopia) { this.kopia.remove(); this.kopia = null; }
    this.orig.hidden = !!on;
    if (!on) return;
    var o = this.orig, lead = this.lead, naglowek = o.querySelector('[data-wyniki-naglowek]') || o.tHead.rows[0], glowa = naglowek.cells;
    var sumy = o.querySelector('[data-wyniki-sumy]');
    var wiersze = Array.prototype.filter.call(o.tBodies[0].rows, function (r) { return r.style.display !== 'none' && !r.hidden; });
    var k = document.createElement('table'), th = k.createTHead().insertRow(), tb = k.createTBody();
    k.className = o.className + ' sw-osie';
    if (o.caption) k.appendChild(o.caption.cloneNode(true));
    if (sumy) {
      var zakres = sumy.cells[0].cloneNode(true); zakres.scope = 'col'; th.appendChild(zakres);
      zakres.querySelector('[data-wyniki-ile]').value = sumy.querySelector('[data-wyniki-ile]').value;
      zakres.appendChild(sumy.cells[1].cloneNode(true).firstElementChild);
      zakres.appendChild(sumy.querySelector('[data-wyniki-sumy-n]').cloneNode(true));
      var opis = document.createElement('th'); opis.scope = 'col';
      opis.textContent = /^en(?:-|$)/i.test(document.documentElement.lang || '') ? jst("ui.bd82cf16699be29e") : jst("ui.44a1de83dbb0e15b"); th.appendChild(opis);
    } else { th.appendChild(glowa[0].cloneNode(true)); }
    var idx = this.labelIdx;
    wiersze.forEach(function (r) {
      var c = document.createElement('th'); c.scope = 'col';
      c.innerHTML = r.cells[idx].innerHTML; th.appendChild(c);
    });
    for (var j = lead; j < glowa.length; j++) {
      var tr = tb.insertRow(), h = glowa[j].cloneNode(true);
      h.scope = 'row';
      if (sumy) {
        var licznik = document.createElement('td'); licznik.innerHTML = sumy.cells[j].innerHTML;
        licznik.className = 'wyniki-tabela__trafienia-osie'; licznik.setAttribute('data-n', glowa[j].getAttribute('data-wyniki-number'));
        tr.appendChild(licznik);
      }
      tr.appendChild(h);
      // Pusta komorka dostaje numer wiersza (liczbe) — w zwyklym widoku numer
      // rysuje licznik CSS kolumn, ktory po zamianie osi liczylby losowania.
      var n = ((h.textContent || '').match(/\d+/) || [''])[0];  // naglowek moze miec strzalke sortowania
      for (var i = 0; i < wiersze.length; i++) {
        var kom = wiersze[i].cells[j].cloneNode(true);
        kom.removeAttribute('data-sw-hl');
        if (!kom.childNodes.length) kom.setAttribute('data-n', n);
        tr.appendChild(kom);
      }
    }
    o.parentNode.insertBefore(k, o.nextSibling);
    this.kopia = k;
  };

  function start() {
    function wlacz(el) {
      if (el.swWidok) return;
      el.swWidok = new Widok(el);
      el.classList.add('sw-gotowy');
      if (el.hasAttribute('data-wyniki')) {
        var params = new URLSearchParams(window.location.search), view = el.swWidok;
        ['dopasuj', 'osie', 'rytmy'].forEach(function (action) {
          if (params.get(action) !== '1') return;
          var button = el.querySelector('[data-sw-akcja="' + action + '"]');
          if (button) view.akcja(action, button);
        });
        var scale = Number(params.get('skala'));
        if (params.get('dopasuj') === '1' && Number.isFinite(scale) && scale > 1 && scale <= 10 && view.s > 0) {
          view.zoom(scale * view.fit / view.s, view.vp.clientWidth / 2, view.vp.clientHeight / 2);
        }
      }
    }
    var obserwator = window.IntersectionObserver ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        obserwator.unobserve(entry.target);
        wlacz(entry.target);
      });
    }, { rootMargin: '200px' }) : null;
    document.querySelectorAll('[data-sw]').forEach(function (el) {
      if (obserwator) obserwator.observe(el); else wlacz(el);
      // Programowe kliknięcie działa także przed wejściem siatki na ekran.
      el.addEventListener('click', function () { wlacz(el); }, { capture: true, once: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
